import React from "react";
import { Navigate, useLocation } from "react-router-dom";

function OnlyFromRoute({from, element}) {

  const location = useLocation();

  return (
    // location.state?.from === from ? element : <Navigate to="/" replace/>
    (from.indexOf(location.state?.from) > -1) ? element : <Navigate to="/" replace/>
  );
}

export default OnlyFromRoute;
